<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="opened" persistent max-width="600" light>
        <v-card>
          <v-card-title class="headline">{{ title }}</v-card-title>
          <v-divider />
          <v-form ref="form">
            <v-card-text class="mt-3">
              <FacetValuesSelection
                v-model="selectedPackage"
                facet="package"
                type="text"
                :search-by-query="true"
                :multiple="false"
                :rules="[(v) => !!v || 'Required']"
              />
            </v-card-text>
          </v-form>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn v-if="sendMode" :disabled="!selectedPackage" color="success" small @click="sendEmail">
              Envoyer
            </v-btn>
            <v-btn v-else :disabled="!selectedPackage" color="success" small @click="applyPackage">
              Appliquer
            </v-btn>
            <v-btn color="info" small @click="closePopup">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';

import FacetValuesSelection from '@/components/editor/Customs/RuleForms/ActionFormFields/common/FacetValuesSelection.vue';

// eslint-disable-next-line no-undef
const props = defineProps({
  uuid: {
    type: String,
    default: null
  },
  sendMode: {
    type: Boolean,
    default: false
  },
  previewEmailByProductActive: {
    type: Boolean,
    default: false
  },
  showErrorMessage: { type: Function },
  showSuccessMessage: { type: Function }
});

const store = useStore();

const currentUser = computed(() => store.state.currentUser);

// eslint-disable-next-line no-undef
const emit = defineEmits(['apply-package', 'update:preview-email-by-product-active']);

const form = ref(null);
const selectedPackage = ref(null);

const opened = ref(false);

const open = () => {
  // Opens Modal
  opened.value = true;
};

const closePopup = () => {
  opened.value = false;
  selectedPackage.value = null;
  form.value.reset();
};

const title = ref(props.sendMode ? 'Envoyer un e-mail de test' : 'Sélectionnez le code du package pour prévisualiser');

const applyPackage = () => {
  // Emit applyPackage with info for sendInformation
  emit('apply-package', { switchProductPreview: true, packageCode: selectedPackage.value.value });

  emit('update:preview-email-by-product-active', true);
  closePopup();
};

const defaultRecipients = ['buildermail@ucpa.asso.fr'];

const emailRecipients = ref([]);

const { mutate: sendEmailMutation, onDone, onError } = useMutation(gql(`
      mutation sendEmailToRecipient($uuid: ID, $recipients: [String]!, $packageCode: String, $partner: String) {
        sendEmailToRecipient: ${store.state.environment.PROJECT}SendEmailToRecipient(uuid: $uuid, recipients: $recipients, packageCode: $packageCode, partner: $partner) {
          success
          message
          data
        }
      }
    `), () => ({ variables: { uuid: props.uuid, recipients: emailRecipients.value, packageCode: selectedPackage.value.value, partner: store.state.environment.PROJECT } }));

onDone(result => {
  if (!result.data.sendEmailToRecipient.success) {
    props.showErrorMessage(result.data.sendEmailToRecipient.message);
    return;
  }

  props.showSuccessMessage('E-mail envoyé avec succès');
});

onError(error => {
  console.log('[ERROR] Sending Email ->', error);

  props.showErrorMessage("J'ai corrigé une erreur lors de l'envoi d'un e-mail");
});

const sendEmail = () => {
  emailRecipients.value = [...defaultRecipients];

  if (currentUser.value && currentUser.value.email) emailRecipients.value.push(currentUser.value.email);

  sendEmailMutation();

  closePopup();
};

// eslint-disable-next-line no-undef
defineExpose({ open });

</script>
